import styles from "./SectionThree.module.css";
import Card from "components/Card";

const experiencias = [
    {
        imageName: "img-card01",
        alt: "Logotipo Receita Federal",
        title: "Suporte de TI - Receita Federal, Limeira, SP",
        subtitle: "Prestei suporte técnico em TI para o setor administrativo, atuando na manutenção e configuração de equipamentos, redes e sistemas utilizados pela Receita Federal."
    },
    {
        imageName: "img-card02",
        alt: "Logotipo Prefeitura de Limeira",
        title: "Desenvolvedor Web - Prefeitura de Limeira, SP",
        subtitle: "Responsável pelo desenvolvimento e manutenção de portais e sistemas internos da prefeitura, com foco em otimização e acessibilidade para o cidadão."
    },
    {
        imageName: "img-card03",
        alt: "Logotipo BrainSoft",
        title: "Desenvolvedor de Software - BrainSoft",
        subtitle: "Atuei no desenvolvimento do sistema de PDV e ERP para clientes de diferentes setores, participando de todas as etapas do ciclo de vida do software, com a linguagem Delphi."
    },
    {
        imageName: "img-card04",
        alt: "Logotipo Polihouse do Brasil",
        title: "Desenvolvedor Web - Polihouse do Brasil",
        subtitle: "Fui responsável pela criação e manutenção de sistemas de gestão e automação de processos para o setor industrial, desenvolvendo interfaces intuitivas e funcionais que facilitavam o controle e monitoramento."
    }
];

export default function SectionThree() {
    return (
        <section className={styles.sectionThree}>
            <div className={styles.titleSectionThree}>
                <h2>Experiência Profissional</h2>
            </div>

            <div className={styles.cards}>
                {experiencias.map((exp, idx) => (
                    <Card
                        key={idx}
                        className={styles.card}
                        imageName={exp.imageName}
                        alt={exp.alt}
                        title={exp.title}
                        subtitle={exp.subtitle}
                    />
                ))}
            </div>
        </section>
    );
}